import {
  ApolloLink,
  ApolloClient,
  InMemoryCache,
  createHttpLink,
} from '@apollo/client';
import { store } from '../redux/store';
import cloneDeepWith from 'lodash/cloneDeepWith';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';
import { setErrors } from 'Actions/dashboardActionCreators';
import { notifyDatadogAndAirbrake } from '../monitoring/notifyAirbrakeAndDatadog';

const httpLink = createHttpLink({
  uri: `${import.meta.env.VITE_API_DOMAIN}/graphql`,
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      ...JSON.parse(localStorage.getItem('authTokenHeaders')),
      'location-id': localStorage.getItem('locationId'),
      'business-id': localStorage.getItem('businessId'),
      'X-Version': import.meta.env.VITE_APP_VERSION,
    },
  };
});

const errorLink = onError((errorResponse) => {
  const { networkError, graphQLErrors, forward } = errorResponse;
  if (networkError) {
    if (networkError.statusCode === 401) {
      //store.dispatch(signOutUser());
      store.dispatch(
        setErrors('Your session has expired. Please log in again.')
      );
    } else if (networkError.statusCode === 404) {
      store.dispatch(
        setErrors('The resource you requested is not found - 404.')
      );
      //history.push('/notFound');
    } else if (
      networkError.bodyText || // Not a JSON response, usually 200 httpStatus (ServerParseError)
      typeof networkError.result === 'string' // Not a JSON response, other httpStatus
    ) {
      store.dispatch(
        setErrors(

        )
      );
      const notifyResultPromise = notifyDatadogAndAirbrake(
        'GraphQL response error - Non JSON',
        'Root.jsx',
        errorResponse
      );
      notifyResultPromise.then(notice => {
        const errorMessage = notice.id
          ? `There was an internal failure processing your request, please try again later. \nIf the problem persists please contact support and provide this error code: ${notice.id}`
          : 'There was an internal failure processing your request, please try again later. \nIf the problem persists please contact support. (gql non-json response)';

        store.dispatch(setErrors(errorMessage));
      });

    } else if (graphQLErrors) {
      const errorMessages = [
        'Error while performing this operation. Please contact customer support or try again later. Details:',
        ...graphQLErrors.map((error) => error.message),
      ];
      store.dispatch(setErrors(errorMessages));
    } else {
      const notifyResultPromise = notifyDatadogAndAirbrake(
        'GraphQL response error - other',
        'Root.jsx',
        errorResponse
      );

      notifyResultPromise.then(notice => {
        const errorMessage = notice.id
          ? `There was an internal failure processing your request, please try again later. \nIf the problem persists please contact support and provide this error code: ${notice.id}`
          : 'There was an internal failure processing your request, please try again later. \nIf the problem persists please contact support. (gql error)';

        store.dispatch(setErrors(errorMessage));
      });
    }
  }
});

const omitTypenameDeep = (variables) =>
  cloneDeepWith(variables, (value) => {
    if (value?.__typename) {
      const { __typename, ...valWithoutTypename } = value;
      return omitTypenameDeep(valWithoutTypename);
    }
    return undefined;
  });

const removeTypename = new ApolloLink((operation, forward) => {
  const newOperation = operation;
  newOperation.variables = omitTypenameDeep(newOperation.variables);
  return forward(newOperation);
});

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: errorLink.concat(removeTypename.concat(authLink.concat(httpLink))),
});
